import { ROUTES } from 'constants/routes';

export const editorUrlToViewerUrl = (projectId) => {
  if (!projectId) {
    return ROUTES.viewer.root();
  }
  return ROUTES.viewer.project(projectId).root();
};
